import * as React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import QuizIcon from "@mui/icons-material/Quiz";
import ArchiveIcon from "@mui/icons-material/Archive";
import ExamProcessTable from "./ExamProcessTable";
import { UserContext } from "../app/App";
import FolderList from "./ExaminerPreView";
import "./test.css";
import ArchiveTable from "./ArchiveTable";

export default function CenteredTabs() {
  const [value, setValue] = React.useState(0);
  const [selectedProcess, setSelectedProcess] = React.useState(-1);
  const { user } = React.useContext(UserContext);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /*
  const onDrop = useCallback(acceptedFiles => {
    // this callback will be called after files get dropped, we will get the acceptedFiles. If you want, you can even access the rejected files too
  }, []);*/

  return (
    <>
      {user.role === "BLAK_EMPLOYEE" ? (
        <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="fullWidth"
            sx={{ marginBottom: 4 }}
          >
            <Tab
              label="Aktive Prüfungen"
              icon={<QuizIcon />}
              iconPosition="end"
            />
            <Tab label="Archiv" icon={<ArchiveIcon />} iconPosition="end" />
          </Tabs>
          {value === 0 ? <ExamProcessTable /> : <ArchiveTable />}
        </Box>
      ) : (
        <FolderList
          selectedProcess={selectedProcess}
          setSelectedProcess={setSelectedProcess}
        />
      )}
    </>
  );
}
